import { render, staticRenderFns } from "./DocumentationPage.vue?vue&type=template&id=aa1c654e&scoped=true&"
import script from "./DocumentationPage.vue?vue&type=script&lang=js&"
export * from "./DocumentationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1c654e",
  null
  
)

export default component.exports